import componentImage1 from "../assets/images/Component 13 – 1.png";
import componentImage2 from "../assets/images/Component 14 – 1.png";
import componentImage3 from "../assets/images/Component 15 – 1.png";
import componentImage4 from "../assets/images/Component 16 – 1.png";
import componentImage5 from "../assets/images/Component 17 – 1.png";
import componentImage6 from "../assets/images/Component 18 – 1.png";
import componentImage1Hover from "../assets/images/Component 13 – 1-hover.png";
import componentImage2Hover from "../assets/images/Component 14 – 1-hover.png";
import componentImage3Hover from "../assets/images/Component 15 – 1-hover.png";
import componentImage4Hover from "../assets/images/Component 16 – 1-hover.png";
import componentImage5Hover from "../assets/images/Component 17 –1-hover.png";
import componentImage6Hover from "../assets/images/Component 18 –1-hover.png";

const images = [
  {
    image: componentImage6,

    hoverImage: componentImage6Hover,
    label: "Preview 6",
  },
  {
    image: componentImage1,

    hoverImage: componentImage1Hover,
    label: "Preview 1",
  },
  {
    image: componentImage2,
    hoverImage: componentImage2Hover,
    label: "Preview 2",
  },
  {
    image: componentImage3,
    hoverImage: componentImage3Hover,
    label: "Preview 3",
  },
  {
    image: componentImage4,
    hoverImage: componentImage4Hover,
    label: "Preview 4",
  },
  {
    image: componentImage5,
    hoverImage: componentImage5Hover,
    label: "Preview 5",
  },
];

const Description = () => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 sm:gap-6 place-items-center p-4 sm:p-6    sm:mb-6">
      {images.map(({ image, hoverImage, label }, index) => (
        <div
          key={index}
          className="relative group w-40 h-[291px] overflow-hidden rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
          tabIndex={0}
          aria-label={label || `Preview ${index + 1}`}
        >
          {/* Default (non-hover) image */}
          <img
            src={image}
            alt={label || `Component preview ${index + 1}`}
            className="absolute top-0 left-1/2 -translate-x-1/2 h-[146px] w-[134px] object-contain transition-opacity duration-300 ease-in-out group-hover:opacity-0 group-focus:opacity-0 motion-reduce:transition-none"
            loading="lazy"
            decoding="async"
            draggable="false"
          />

          {/* Hover/focus image */}
          <img
            src={hoverImage}
            alt=""
            aria-hidden="true"
            className="absolute top-0 left-1/2 -translate-x-1/2 h-[291px] w-40 object-contain opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100 group-focus:opacity-100 motion-reduce:transition-none"
            loading="lazy"
            decoding="async"
            draggable="false"
          />
        </div>
      ))}
    </div>
  );
};

export default Description;
